import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import AutoComplete1 from "../../Utils/Select";
import {
  getUserRoleChangeData,
  getUserManagementData,
} from "../../Redux/Actions/UserManagementAction";
import { useDispatch, useSelector } from "react-redux";

const roles = [
  {
    label: "AGENT",
    value: "AGENT",
  },
  {
    label: "SUPER_USER",
    value: "SUPER_USER",
  },
  {
    label: "AGENCY_ADMIN",
    value: "AGENCY_ADMIN",
  },
];
const PopUp = (props) => {
  const {
    userDetails,
    setUserDetails,
    setSnackBarSeverity,
    setSnackBarMsg,
    setSnackBarOpen,
  } = props;
  const dispatch = useDispatch();
  const [roleChange, setRoleChange] = useState({ label: "select", value: "" });
  const [agencyArray, setAgencyArray] = useState([]);
  //const [roleArray, setroleArray] = useState([]); Sonar.
  const UserRoleChangeDataFiltered = useSelector(
    (state) => state.user.UserRoleChangeDataFiltered
  );

  useEffect(() => {
    if (userDetails?.agencyId?.trim() !== "") {
      let arr = userDetails?.agencyId?.split(",").map((id) => id.trim());
      setAgencyArray(arr);
    }
    // if (userDetails?.roleDesc?.trim() !== "") {
    //   let roleid = userDetails?.roleDesc?.split(",").map((id) => id.trim());
    //   setroleArray(roleid);
    // } .. Sonar
  }, [userDetails]);

  useEffect(() => {}, [UserRoleChangeDataFiltered]);

  const handleAutocompleteChange = (value, type) => {
    if (type === "roleChange") {
      if (roleChange && roleChange.value === value.value) {
        return;
      }

      setRoleChange({
        ...roleChange,
        value: value.value,
        label: value.label,
      });
    } else if (type === "agencyChange") {
      setUserDetails((prevDetails) => ({
        ...prevDetails,
        agencyId: value.label,
      }));
    }
  };

  const handleSubmit = async () => {
    const defaultRole = userDetails.roleDesc;
    const payload = {
      userDetailsList: [
        {
          firstName: userDetails.firstName,
          lastName: userDetails.lastName,
          userId: userDetails.userId,
          emailId: userDetails.emailId,
          agentId: userDetails.agentId,
          agencyId: userDetails.agencyId,
          roleDesc: userDetails.roleDesc,
        },
      ],
      newRoleDesc: roleChange?.value || defaultRole,
    };
    if(roleChange?.value){
    let response = dispatch(getUserRoleChangeData(payload));
    response.then((value) => {
      if (value?.data?.status !== "FAILURE") {
        dispatch(getUserManagementData());
        setRoleChange({ label: "select", value: "" });
         // Show snackbar
         setSnackBarSeverity("success");
         setSnackBarMsg("Role changed successfully!");
         setSnackBarOpen(true);
      }
    });
  }else{
         setRoleChange({ label: "select", value: "" });
         setSnackBarSeverity("warning");
         setSnackBarMsg("Please select Role!");
         setSnackBarOpen(true);
  }
  };

  return (
    <div
      id="usermangmntPopup"
      className="modal fade z-index-1051"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title">User Information</h4>
            <button type="button" className="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div className="modal-body">
            <div className="panel-body campaignsingle">
              <div className="form-panel2">
                <div className="row">
                  <span className="col-lg-4 col-md-6 col-sm-12 mb-2">
                    <span className="label-container">
                      <label className="labelcampaign" htmlFor="fname">
                        First Name
                      </label>
                      <br />
                      <TextField
                        name="fname"
                        value={userDetails.firstName}
                        size="small"
                        className="prospectwidth9"
                        variant="outlined"
                      />
                    </span>
                  </span>
                  <span className="col-lg-4 col-md-6 col-sm-12 mb-2">
                    <span className="label-container">
                      <label className="labelcampaign" htmlFor="lname">
                        Last Name
                      </label>
                      <br />
                      <TextField
                        name="lname"
                        value={userDetails.lastName}
                        size="small"
                        className="prospectwidth9"
                        variant="outlined"
                      />
                    </span>
                  </span>
                  <span className="col-lg-4 col-md-6 col-sm-12 mb-2">
                    <span className="label-container">
                      <label className="labelcampaign" htmlFor="userId">
                        User ID
                      </label>
                      <br />
                      <TextField
                        name="userId"
                        value={userDetails.userId}
                        size="small"
                        className="prospectwidth9"
                        variant="outlined"
                      />
                    </span>
                  </span>

                  <span className="col-lg-4 col-md-6 col-sm-12 mb-2">
                    <span className="label-container">
                      <label className="labelcampaign" htmlFor="emailId">
                        Email ID
                      </label>
                      <br />
                      <TextField
                        name="emailId"
                        value={userDetails.emailId}
                        size="small"
                        className="prospectwidth9"
                        variant="outlined"
                      />
                    </span>
                  </span>
                  <span className="col-lg-4 col-md-6 col-sm-12 mb-2">
                    <span className="label-container">
                      <label className="labelcampaign" htmlFor="agentId">
                        Agent ID
                      </label>
                      <br />
                      <TextField
                        name="agentId"
                        value={userDetails.agentId}
                        size="small"
                        className="prospectwidth9"
                        variant="outlined"
                      />
                    </span>
                  </span>
                  <span className="col-lg-4 col-md-6 col-sm-12 mb-2">
                    <span className="label-container">
                      <label className="labelcampaign" htmlFor="agencyId">
                        Agency ID
                      </label>
                      <br />
                      <AutoComplete1
                        height="7px !important"
                        width="236px"
                        options={agencyArray.map((id, index) => ({
                          label: id,
                          value: `${index + 1}`,
                        }))}
                        value={agencyArray.find(
                          (option) => option === userDetails.agencyId
                        )}
                        handleChange={(value) =>
                          handleAutocompleteChange(value, "agencyChange")
                        }
                      />
                    </span>
                  </span>

                  <span className="col-lg-4 col-md-6 col-sm-12 mb-2">
                    <span className="label-container">
                      <label className="labelcampaign" htmlFor="role">
                        Role
                      </label>
                      <br />

                      <AutoComplete1
                        name="roleChange"
                        height="7px !important"
                        width="236px"
                        options={roles}
                        value={roles.find(
                          (option) => option.value === roleChange.value
                        )??{label:"",value:''}}
                        handleChange={handleAutocompleteChange}
                      />
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              id="submit"
              className="btn btn-dashboard-active"
              data-dismiss="modal"
              onClick={() => handleSubmit()}
            >
              Save
            </button>
            <button className="btn btn-campaign" data-dismiss="modal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopUp;
